export class Login {
  public username: string;
  public password: string;
  public applicationid = 2;
}
export class Session {
  public token: string;
  public user: Login;
}

export class PassResc {
  email: String;
  code: String;
  password: String;
  passwordConfirm: String;
}



// WEBPACK FOOTER //
// ./src/app/web/login-object.model.ts